import { createReducer, createSelector } from 'redux-starter-kit';
import { putCreditPackages } from './creditPackageActions';

/**
 * A selector for the credit packages loaded in the domain state.
 * This is a list: [ creditPackage, creditPackage, ...]
 * @param {object} state The redux state of the application.
 * @returns An array of credit package objects.
 * @example const damageAreas = selectCreditPackages(state);
 */
export const selectCreditPackages = createSelector(['via.domain.creditPackages'], map => (map ? Object.values(map) : null));

/**
 * A selector for the matching credit package.
 * @param {object} state The redux state of the application.
 * @param {number} creditPackageCode The id of the credit package.
 * @returns {object} The credit package. (Null if it doesn't exist).
 */
export const selectCreditPackage = (state, creditPackageCode) => state.via.domain.creditPackages[creditPackageCode];


/**
 * A dict object that stores all the packages as key: values.
 */
const initialCreditPackagesState = {
  // creditPackageCode: { /* package details */ }
};

/**
 * The reducer for handling credit package state in the domain.
 */
export default createReducer(initialCreditPackagesState, {
  // Replaces all the credit packages in the state.
  [putCreditPackages]: (state, action) => {
    const packages = action.payload;

    // Builds a dict object. code => package
    return packages.reduce((newState, creditPackage) => {
      newState[creditPackage.code] = creditPackage; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialCreditPackagesState });
  },
});
